import * as React from 'react';
import type { GetStaticProps } from 'next';
import { createClient, notify } from '@/logging/bugnsag';
import { queryFooter, queryNavbar } from '@/clients/queries';
import { FooterQuery, NavbarQuery } from 'types/generated';
import PageContainer from '@/components/PageContainer';
import { apolloClient } from '@/utils/contentful';
import SearchPage from '@/components/Search/SearchPage';
import { ApolloProvider } from '@apollo/client';
import { createApolloClientForSearch } from '@/clients/apollo';
import { getRadioSchedules } from '@/clients/RadioUtils';
import { RadioSchedule } from '@/models/RadioTypes';

const bugsnagClient = createClient(process.env.BUGSNAG_API_KEY || '', process.env.NODE_ENV || 'develop');

type Props = {
  navbar: NavbarQuery;
  footer: FooterQuery;
  radioSchedules: Record<string, RadioSchedule[]>;
};

const RouteComponent = ({ navbar, footer, radioSchedules }: Props) => {
  const mainNavbarData = navbar.navbarCollection?.items?.[0];

  return (
    <PageContainer
      title="Sýn | Leit"
      metaTags={{
        title: 'Sýn leit',
        url: 'https://www.syn.is/leit',
        keywords: 'syn,leit',
        image: { url: '/android-chrome-192x192.png' },
      }}
      navbar={navbar}
      footer={footer}
      radioSchedules={radioSchedules}
    >
      <div className="w-screen pt-128">
        <ApolloProvider client={createApolloClientForSearch()}>
          <SearchPage suggestions={mainNavbarData?.searchSuggestionsCollection?.items || []} />
        </ApolloProvider>
      </div>
    </PageContainer>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  try {
    return {
      props: {
        navbar: (await queryNavbar(apolloClient)).data,
        footer: (await queryFooter(apolloClient)).data,
        radioSchedules: await getRadioSchedules(),
      },
    };
  } catch (err) {
    notify(bugsnagClient, err as Error);
    throw err;
  }
};

export default RouteComponent;
